import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StringKeys } from 'src/types/base';
import {
  SUBSCRIPTION_INTERVAL,
  SUBSCRIPTION_NAME,
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_CODE
} from 'src/types/enum';

export type SubscriptionInfo = Partial<{
  tier_code: SUBSCRIPTION_CODE;
  tier_name: SUBSCRIPTION_NAME;
  status: SUBSCRIPTION_STATUS;
  seats: number;
  is_card_linked: boolean;
  plan_id: number;
  billing_period: SUBSCRIPTION_INTERVAL;
  expiry_on: string;
  last_synced: string;
  created_on: string;
  modified_on: string;
  cancel_at_period_end: boolean;
  remaining_days: number;
  [key: string]: any;
}>;

type LibraryReducer = {
  namespaceId: string;
  selectedFolderId?: string;
  tenant_info: StringKeys;
  subscriptionInfo: SubscriptionInfo;
  createdFileIds: number[];
  analyticsSalt?: string;
};

const initialState: LibraryReducer = {
  namespaceId: '',
  tenant_info: {},
  subscriptionInfo: {},
  selectedFolderId: undefined,
  createdFileIds: [],
  analyticsSalt: null
};

const LibrarySlice = createSlice({
  name: 'library',
  initialState,
  reducers: {
    setTenantInfo(state, action) {
      state.tenant_info = action.payload;
    },
    setNamespaceId(state, action) {
      state.namespaceId = action.payload;
    },
    setSelectedFolderId(state, action) {
      state.selectedFolderId = action.payload;
    },
    setCreatedFilesId(state, action) {
      state.createdFileIds = !!action.payload.length
        ? [...state.createdFileIds, ...action.payload]
        : action.payload;
    },

    setSubscriptionInfo(state, action) {
      state.subscriptionInfo = action.payload;
    },
    setAnalyticsSalt(state, action) {
      state.analyticsSalt = action.payload;
    }
  }
});

export default LibrarySlice;
export const reducer = LibrarySlice.reducer;
export const {
  setNamespaceId,
  setSelectedFolderId,
  setTenantInfo,
  setCreatedFilesId,
  setSubscriptionInfo,
  setAnalyticsSalt
} = LibrarySlice.actions;
